import { NavItemList } from "../GlobalNavigation.types";

export const filterNavItems = (items?: NavItemList): NavItemList => {
  if (!items?.length) {
    return [];
  }

  return items.filter((item) => item?.props?.isGlobalNav);
};
